import { render, staticRenderFns } from "./AccountMarket.vue?vue&type=template&id=e2a367d2&scoped=true&"
import script from "./AccountMarket.vue?vue&type=script&lang=ts&"
export * from "./AccountMarket.vue?vue&type=script&lang=ts&"
import style0 from "./AccountMarket.vue?vue&type=style&index=0&id=e2a367d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2a367d2",
  null
  
)

export default component.exports